module.exports = __webpack_public_path__ + "f2489ac857e9b4d409fadcd4059ff0dd.pdf";